@import '~style-sheet-helpers/core.less';
@import '../../../../constants/spacing.module.less';

.freemium-shipping-calculator {
  display: flex;
  max-width: 1000px;
  height: 304px;
  width: 100%;
  margin: 80px auto 0;
  border: 1px solid var(--gray-E4E5E7);
  border-radius: 8px;
  background-color: var(--white);
  box-shadow:
    0 2px 4px 0 rgba(0, 0, 0, 0.1),
    0 0 6px 0 rgba(0, 0, 0, 0.1);

  .weight-inputs-container {
    width: 100%;
  }

  .weight-number-input {
    flex: 1;
    max-width: none;
  }
}

.calculator-section {
  flex: 1;
  padding: @space-24;
  background: var(--white);
  display: flex;
  flex-direction: column;
  gap: @space-12;
  justify-content: space-between;
  border-radius: 8px;
}

.input-label {
  display: block;
  text-align: left;
  margin-bottom: @space-8;
  font-weight: 500;
  font-size: 14px;
  color: @grey-850;
}

.zip-codes {
  position: relative;
  display: flex;
  align-items: flex-end;
  gap: @space-8;
  width: 100%;
}

.origin-zip {
  position: relative;
  flex: 1;
}

.zip-input.zip-input {
  width: 100%;
  border-radius: 4px;

  input {
    height: 35px;
  }
}

.zip-arrow {
  margin: @space-0 @space-8;
  color: @grey-700;
  width: 16px;
  height: 34px;
  flex-shrink: 0;
}

.destination-zip {
  position: relative;
  flex: 1;
}

.package-type-dropdown {
  flex: 1;
  position: relative;
  max-height: 53px;

  .dropdown-menu {
    width: 100%;

    .dropdown-menu-toggler.dropdown-menu-toggler {
      width: 100%;
      padding: @space-4 @space-12;
      border: 1px solid @cool-grey-400;
      border-radius: 4px;
      background-color: var(--white);
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 10px;
      line-height: unset;

      &::after {
        content: '';
        width: 10px;
        height: 10px;
        background-size: contain;
        background-repeat: no-repeat;
        pointer-events: none;
      }
    }

    .dropdown-menu-item {
      padding: @space-8 @space-12;

      &:hover {
        background-color: @grey-100;
      }
    }

    .dropdown-menu-item-group-label {
      padding: @space-8 @space-12;
      font-weight: 600;
      color: @grey-850;
      background-color: @grey-100;
    }
  }
}

.weight-inputs {
  align-items: flex-start;
}

.weight-inputs-container {
  display: flex;
  align-items: center;
  gap: @space-8;
}

.weight-input {
  width: auto;
  display: flex;
  align-items: center;
  border: none;
  background: transparent;
}

.weight-number-input {
  display: flex;
  justify-content: center;
  max-width: 100px;
  text-align: center;
  border: 1px solid var(--default--dropdown--border-color--1);
  border-radius: 4px;
  height: 35px;
}

.number-input {
  .arrow-button-group {
    margin-left: @space-4;

    .arrow-button {
      border: 1px solid @cool-grey-400;
      border-radius: 4px;
      background-color: var(--white);
      color: @grey-850;

      &:hover {
        background-color: @grey-100;
      }
    }
  }

  .custom-number-input {
    input[type='number'] {
      border: 1px solid var(--default--dropdown--border-color--1);
      border-radius: 4px;
      padding: @space-0 @space-8;
      text-align: center;

      &:focus {
        border-color: @purple-600;
        outline: none;
      }
    }
  }
}

.unit {
  .unit-label {
    color: @grey-850;
    margin: @space-0 @space-8;
    font-size: 14px;
  }
}

.get-rates-button {
  height: 40px;
  width: 100%;
  padding: @space-12;
  align-self: flex-start;
}

@media screen and (max-width: 768px) {
  .freemium-shipping-calculator {
    flex-direction: column;
    height: auto;
    min-height: 304px;
  }

  .calculator-section {
    padding: @space-20;
  }

  .zip-codes {
    flex-direction: column;
    align-items: flex-start;
    gap: @space-12;
  }

  .origin-zip,
  .destination-zip {
    width: 100%;
  }

  .zip-arrow {
    display: none;
  }

  .package-type-dropdown {
    width: 100%;
  }

  .weight-inputs-container {
    width: 100%;
  }
}
